(function () {
  // Fully data-driven diagnosis engine — the question graph and the
  // product/testimonial data per outcome both come from
  // sections/content-diagnosis-tool.liquid's blocks (question/answer/
  // diagnosis_product), rendered into two <script type="application/json">
  // blobs. No question text or branching is hardcoded here anymore, so
  // the same engine works for any brand's own quiz just by editing blocks
  // in the theme editor.
  //
  // Question node shape: { text, layout: 'grid'|'pills'|'list', answers: [
  //   { label, letter, icon, target }
  // ] }
  // `target` is either another question's id, or 'result:KEY' for a leaf,
  // where KEY matches a result key a 'diagnosis_product' block declares
  // (a product block can list several comma-separated result keys, so one
  // product can be the answer to more than one outcome).

  // Registered as a theme.sections section type (see bottom of file), so
  // this re-runs — re-parsing the JSON and re-binding the modal opener —
  // whenever the theme editor hot-reloads this section (e.g. after saving
  // a block). A one-time DOMContentLoaded init would otherwise go stale:
  // editor section reloads swap in new markup without re-executing any
  // <script> tags in it.
  function KinujoDiagnosis(container) {
    this.container = container;
    this.root = container.querySelector('[data-kinujo-diagnosis]');
    if (!this.root) return;

    this.questions = {};
    try {
      var qScript = this.root.querySelector('[data-diagnosis-questions-json]');
      if (qScript) this.questions = JSON.parse(qScript.textContent);
    } catch (e) {
      this.questions = {};
    }

    this.resultsData = {};
    try {
      var rScript = this.root.querySelector('[data-diagnosis-results-json]');
      if (rScript) this.resultsData = JSON.parse(rScript.textContent);
    } catch (e) {
      this.resultsData = {};
    }

    this.startId = this.root.getAttribute('data-start-question-id') || 'q1';
    this.totalSteps = this.computeMaxDepth(this.startId) || 1;

    this.historyStack = [];
    this.current = this.startId;

    this.body = this.root.querySelector('[data-diagnosis-body]');
    this.progress = this.root.querySelector('[data-diagnosis-progress]');
    this.backButton = this.root.querySelector('[data-diagnosis-back]');
    this.heading = this.root.querySelector('[data-diagnosis-heading]');
    this.questionHeadingText = this.heading ? this.heading.getAttribute('data-question-heading') : '';
    this.resultHeadingText = this.heading ? this.heading.getAttribute('data-result-heading') : '';

    if (this.backButton) {
      this.backButton.addEventListener('click', this.goBack.bind(this));
    }

    if (window.theme && theme.Modals && container.id) {
      new theme.Modals(container.id, 'kinujo-diagnosis');
      // theme.Modals dispatches these on `document`, namespaced by the
      // modal wrapper's own element id, whenever it's opened/closed.
      document.addEventListener('modalOpen.' + container.id, this.reset.bind(this));

      // theme.Modals only adds the desktop-only .modal-open body class
      // itself (theme.css.liquid scopes that rule to min-width:769px) —
      // components that also need the page locked on mobile call
      // theme.a11y.lockMobileScrolling themselves (see Drawers/Newsletter/
      // AgeVerification in theme.js), which this generic modal never did,
      // so the page behind it kept scrolling on phones.
      if (window.theme.a11y && typeof theme.a11y.lockMobileScrolling === 'function') {
        var scrollLockNamespace = '.kinujo-diagnosis-' + container.id;
        document.addEventListener('modalOpen.' + container.id, function () {
          theme.a11y.lockMobileScrolling(scrollLockNamespace);
        });
        document.addEventListener('modalClose.' + container.id, function () {
          theme.a11y.unlockMobileScrolling(scrollLockNamespace);
        });
      }
    }

    this.render();
  }

  // Longest path (in answers) from a question to a result leaf — used only
  // to scale the progress bar. Computed from the actual data so it stays
  // correct no matter how the merchant restructures the quiz.
  KinujoDiagnosis.prototype.computeMaxDepth = function (startId) {
    var questions = this.questions;
    var memo = {};

    function depth(id, seen) {
      if (memo[id] !== undefined) return memo[id];
      if (seen[id]) return 0; // guard against an accidental loop in the data
      var nextSeen = Object.assign({}, seen);
      nextSeen[id] = true;

      var node = questions[id];
      if (!node) return 0;

      var max = 0;
      (node.answers || []).forEach(function (answer) {
        var target = answer.target;
        if (target && target.indexOf('result:') !== 0 && questions[target]) {
          max = Math.max(max, 1 + depth(target, nextSeen));
        } else {
          max = Math.max(max, 1);
        }
      });

      memo[id] = max;
      return max;
    }

    return depth(startId, {});
  };

  KinujoDiagnosis.prototype.reset = function () {
    this.historyStack = [];
    this.current = this.startId;
    this.render();
  };

  KinujoDiagnosis.prototype.goBack = function () {
    if (!this.historyStack.length) return;
    this.current = this.historyStack.pop();
    this.render();
  };

  KinujoDiagnosis.prototype.go = function (target) {
    this.historyStack.push(this.current);
    this.current = target;
    this.render();
  };

  KinujoDiagnosis.prototype.render = function () {
    if (!this.body) return;

    if (this.backButton) {
      this.backButton.hidden = this.historyStack.length === 0;
    }

    if (this.current && this.current.indexOf('result:') === 0) {
      var key = this.current.slice('result:'.length);
      if (this.heading) this.heading.textContent = this.resultHeadingText;
      this.renderResult(key);
      if (this.progress) this.progress.style.width = '100%';
      return;
    }

    if (this.heading) this.heading.textContent = this.questionHeadingText;

    var node = this.questions[this.current];
    if (!node) {
      this.renderMissing();
      return;
    }

    if (this.progress) {
      // historyStack.length is how many questions are already answered
      // (0 on the very first question), so the bar starts near-empty
      // instead of already a quarter full — a small floor keeps a sliver
      // visible rather than a literal 0% on that first question.
      var completed = this.historyStack.length;
      var percent = Math.round((completed / this.totalSteps) * 100);
      this.progress.style.width = Math.min(100, Math.max(2, percent)) + '%';
    }

    this.renderQuestion(node);
  };

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  KinujoDiagnosis.prototype.renderMissing = function () {
    this.body.innerHTML = '';
    var card = el('div', 'kinujo-diagnosis__question-card');
    card.appendChild(el('p', 'kinujo-diagnosis__question-text', 'この質問は準備中です。'));
    this.body.appendChild(card);
  };

  KinujoDiagnosis.prototype.renderQuestion = function (node) {
    var self = this;
    this.body.innerHTML = '';

    var card = el('div', 'kinujo-diagnosis__question-card');
    var step = this.historyStack.length + 1;
    var numberLabel = document.createElement('span');
    numberLabel.className = 'kinujo-diagnosis__question-number';
    numberLabel.innerHTML = 'Question <strong>' + (step < 10 ? '0' + step : step) + '</strong>';
    card.appendChild(numberLabel);
    var questionText = el('p', 'kinujo-diagnosis__question-text');
    // Merchant-entered via the theme editor (not customer input), so HTML
    // tags like <br> are trusted and rendered rather than escaped.
    questionText.innerHTML = node.text;
    card.appendChild(questionText);
    this.body.appendChild(card);

    var listClass = 'kinujo-diagnosis__options';
    if (node.layout === 'grid') listClass += ' kinujo-diagnosis__options--letters';
    if (node.layout === 'pills') listClass += ' kinujo-diagnosis__options--yesno';

    var list = el('div', listClass);
    (node.answers || []).forEach(function (answer) {
      var btn = el('button', 'kinujo-diagnosis__option' + (node.layout === 'pills' ? ' kinujo-diagnosis__option--pill' : ''));
      btn.type = 'button';

      if (answer.letter) {
        btn.appendChild(el('span', 'kinujo-diagnosis__option-letter', answer.letter));
      }
      var labelEl = el('span', 'kinujo-diagnosis__option-label');
      labelEl.innerHTML = answer.label;
      btn.appendChild(labelEl);
      if (answer.icon) {
        var iconWrap = el('span', 'kinujo-diagnosis__option-icon');
        var img = document.createElement('img');
        img.src = answer.icon;
        img.alt = '';
        iconWrap.appendChild(img);
        btn.appendChild(iconWrap);
      }

      btn.addEventListener('click', function (event) {
        // theme.Modals treats a click as "outside the modal" once its
        // target is detached from the DOM, which is exactly what
        // this.render()'s innerHTML reset does to the very button that
        // was clicked — stopping propagation here keeps that click from
        // ever reaching the modal's own close-on-outside-click listener.
        event.stopPropagation();
        if (answer.target) self.go(answer.target);
      });
      list.appendChild(btn);
    });
    this.body.appendChild(list);
  };

  KinujoDiagnosis.prototype.renderResult = function (key) {
    this.body.innerHTML = '';
    var data = this.resultsData[key];

    if (!data || !data.product) {
      // No product assigned to this outcome yet — fail gracefully rather
      // than showing a broken/empty result screen.
      var fallback = el('div', 'kinujo-diagnosis__question-card');
      fallback.appendChild(el('p', 'kinujo-diagnosis__question-text', 'ただいま準備中です。診断結果は近日公開いたします。'));
      this.body.appendChild(fallback);
      return;
    }

    var wrap = el('div', 'kinujo-diagnosis__result');

    var productEl = el('div', 'kinujo-diagnosis__result-product');
    if (data.product.image) {
      var imageWrap = el('div', 'kinujo-diagnosis__result-image');
      var img = document.createElement('img');
      img.src = data.product.image;
      img.alt = data.product.title || '';
      imageWrap.appendChild(img);
      productEl.appendChild(imageWrap);
    }

    var infoEl = el('div', 'kinujo-diagnosis__result-info');
    infoEl.appendChild(el('h3', 'kinujo-diagnosis__result-title', data.product.title));
    if (data.product.subtitle) {
      infoEl.appendChild(el('p', 'kinujo-diagnosis__result-subtitle', data.product.subtitle));
    }
    if (data.product.description) {
      infoEl.appendChild(el('p', 'kinujo-diagnosis__result-description', data.product.description));
    }
    if (data.product.url || data.product.variantId) {
      var actions = el('div', 'kinujo-diagnosis__result-actions');

      if (data.product.url) {
        var link = document.createElement('a');
        link.href = data.product.url;
        link.className = 'kinujo-diagnosis__result-button';
        link.appendChild(el('span', null, 'View more'));
        actions.appendChild(link);
      }

      if (data.product.variantId && data.product.hasVariants) {
        // type="button" (not "submit") so clicking this never fires a form
        // submit event at all — cart-drawer apps (e.g. UpCart) install a
        // global, capture-phase listener for any /cart/add form submit and
        // handle it themselves before our own handler would ever run, so
        // preventDefault() inside a submit listener can't reliably stop
        // that. A plain click listener has nothing for that global
        // interception to catch. quick-shop-trigger.js opens the same
        // Quick Shop modal the regular product grid uses, so the shopper
        // can pick a variant before adding to cart.
        var quickShopButton = el('button', 'kinujo-diagnosis__buy-button', 'BUY');
        quickShopButton.type = 'button';
        quickShopButton.addEventListener('click', function (event) {
          event.stopPropagation();
          if (!window.KinujoQuickAdd) return;

          if (data.product.variantGroup) {
            window.KinujoQuickAdd.openGroup(data.product.variantGroup.split(','), data.product.variantGroupLabel);
          } else {
            window.KinujoQuickAdd.open(data.product.handle);
          }
        });
        actions.appendChild(quickShopButton);
      } else if (data.product.variantId) {
        // A real <form> (not just a button + JSON fetch) — matching
        // content-product-showcase.js's BUY button — because cart-drawer
        // apps overwhelmingly hook into real /cart/add form submissions
        // rather than arbitrary fetch() calls, so this is what actually
        // gets picked up reliably. Still intercepted below purely to avoid
        // a full-page redirect; no return_to field means nowhere to redirect
        // to even without the preventDefault.
        var buyForm = document.createElement('form');
        buyForm.className = 'kinujo-diagnosis__buy-form';
        buyForm.method = 'post';
        buyForm.action = '/cart/add';

        var variantInput = document.createElement('input');
        variantInput.type = 'hidden';
        variantInput.name = 'id';
        variantInput.value = data.product.variantId;
        buyForm.appendChild(variantInput);

        var buyButton = el('button', 'kinujo-diagnosis__buy-button', 'BUY');
        buyButton.type = 'submit';
        var buyButtonLabel = buyButton.textContent;
        buyForm.appendChild(buyButton);

        buyForm.addEventListener('submit', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (buyButton.disabled) return;

          buyButton.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(buyForm)
          })
            .then(function (response) {
              if (!response.ok) throw new Error('cart add failed');
              // A cart-drawer app listening for cart/add submissions picks
              // this up and opens on its own — this button just needs to
              // give feedback in case it doesn't, rather than navigating
              // anywhere.
              buyButton.textContent = '追加しました';
              setTimeout(function () {
                buyButton.textContent = buyButtonLabel;
                buyButton.disabled = false;
              }, 1500);
            })
            .catch(function () {
              buyButton.disabled = false;
            });
        });
        actions.appendChild(buyForm);
      }

      infoEl.appendChild(actions);
    }
    productEl.appendChild(infoEl);
    wrap.appendChild(productEl);

    if (data.testimonial && data.testimonial.text) {
      var testimonialEl = el('div', 'kinujo-diagnosis__testimonial');
      if (data.testimonial.avatar) {
        var avatarWrap = el('div', 'kinujo-diagnosis__testimonial-avatar-wrap');
        var labelImg = document.createElement('img');
        labelImg.className = 'kinujo-diagnosis__testimonial-label';
        labelImg.src = 'https://cdn.shopify.com/s/files/1/0649/1432/5690/files/kinujo_txt_review.webp?v=1787539089';
        labelImg.alt = 'Salon Review';
        avatarWrap.appendChild(labelImg);
        var avatarInner = el('div', 'kinujo-diagnosis__testimonial-avatar');
        var avatarImg = document.createElement('img');
        avatarImg.src = data.testimonial.avatar;
        avatarImg.alt = data.testimonial.author ? data.testimonial.author + 'さんの写真' : '';
        avatarInner.appendChild(avatarImg);
        avatarWrap.appendChild(avatarInner);
        testimonialEl.appendChild(avatarWrap);
      }
      var testimonialBody = el('div', 'kinujo-diagnosis__testimonial-body');
      if (data.testimonial.heading) {
        testimonialBody.appendChild(el('p', 'kinujo-diagnosis__testimonial-heading', data.testimonial.heading));
      }
      if (data.testimonial.author) {
        testimonialBody.appendChild(el('p', 'kinujo-diagnosis__testimonial-author', data.testimonial.author));
      }
      testimonialBody.appendChild(el('p', 'kinujo-diagnosis__testimonial-text', data.testimonial.text));
      testimonialBody.appendChild(el('p', 'kinujo-diagnosis__testimonial-disclaimer', '※個人の感想です。'));
      testimonialEl.appendChild(testimonialBody);
      wrap.appendChild(testimonialEl);
    }

    if (data.relatedProducts && data.relatedProducts.length) {
      var relatedEl = el('div', 'kinujo-diagnosis__related');
      relatedEl.appendChild(el('h4', 'kinujo-diagnosis__related-heading', 'Related Products'));
      var grid = el('div', 'kinujo-diagnosis__related-grid');
      data.relatedProducts.forEach(function (product) {
        var card = document.createElement('a');
        card.className = 'kinujo-diagnosis__related-item';
        card.href = product.url;
        if (product.image) {
          var img2 = document.createElement('img');
          img2.src = product.image;
          img2.alt = product.title || '';
          card.appendChild(img2);
        }
        card.appendChild(el('span', 'kinujo-diagnosis__related-title', product.title));
        grid.appendChild(card);
      });
      relatedEl.appendChild(grid);
      wrap.appendChild(relatedEl);
    }

    this.body.appendChild(wrap);
  };

  function register() {
    if (window.theme && theme.sections && typeof theme.sections.register === 'function') {
      theme.sections.register('content-diagnosis-tool', KinujoDiagnosis);
    } else {
      // theme.js hasn't defined theme.sections yet — fall back to a
      // plain one-time init (still works for a normal page load, just
      // won't self-heal after a theme-editor section reload).
      document.querySelectorAll('[data-section-type="content-diagnosis-tool"]').forEach(function (container) {
        new KinujoDiagnosis(container);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', register);
  } else {
    register();
  }
})();
